/* TODO: https://auctane.atlassian.net/browse/SPD-16439 need to reorganize context/component, parent/child relationships
    STOP GAP - because of the component hierarchy, and that drawers are NOT modals that break out of the DOM hierarchy
    As consequence subscription card, which owns change sub button, which owns the manage sub drawer
    has a text-align:right css that is trickling down here...
  */
.manage-subscription-drawer {
  text-align: left;
}

.scroll-container {
  overflow: auto;
}

.drawer-body {
  padding: var(--space-24);
  flex: 1;
  display: grid;
  grid-template-columns: auto minmax(260px, 350px);
  grid-template-rows: auto;
  gap: var(--space-16) 0;

  @media (--ultrawide) {
    max-width: 1615px;
    margin: auto;
  }

  @media (--desktop) {
    padding: var(--space-16);
  }
  @media (--tablet), (--mobile), (--ultramobile) {
    padding: var(--space-8);
    grid-template-columns: 1fr;
  }
}

.collapsible-section-column {
  padding-right: var(--space-24);

  @media (--tablet), (--mobile), (--ultramobile) {
    padding-right: var(--space-8);
  }
}

.drawer-banner {
  grid-column: 1 / -1;
}
